import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DmsCallService } from 'src/app/services/dms-call.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  companyName: any;
logo:any
constructor(
    private commonService: CommonService,
    private dmsCallService: DmsCallService
  ) { }

  ngOnInit() {
    this.getSubdomain()
    this.getnav()
  }
 getSubdomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Special case: localhost
    if (hostname === "localhost") {
      this.companyName = "kanbiosys";
      return this.companyName;
    }

    // If there are more than 2 parts, first part is subdomain
    if (parts.length > 2) {
      this.companyName = parts[0];
      return this.companyName;
    }

    // No subdomain
    this.companyName = null;
    return this.companyName;
  }

  getnav() {
  const param = {};
  const head = { BPCode: "", CompanyID: "", auth_Control: "", companyName: this.companyName };
  const dataObj = { param, head };

  this.dmsCallService.getHomeData(dataObj).subscribe({
    next: (result: any) => {
      this.logo = result.logo;

      // console.log(this.logo)
    },
    error: (error: any) => {
      this.commonService.showError(error);
    }
  });
}
}
